import { Dialog, DialogContent, Stack, Typography } from "@mui/material";
import React from "react";
import { AppIcon } from "../StyledComponent";
import { ReactComponent as CloseIcon } from "../../assets/images/CloseIco.svg";

const AppDialog = ({
  open,
  onClose,
  fullWidth = true,
  title = "",
  children,
}) => {
  if (!open) return null;
  return (
    <Dialog open={open} onClose={onClose} fullWidth={fullWidth}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={"space-between"}
        p={2}
      >
        <Typography variant="h4">{title}</Typography>
        <AppIcon onClick={onClose}>
          <CloseIcon />
        </AppIcon>
      </Stack>
      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
};

export default AppDialog;
